<template>
  <div
    class="accordion__wrapper"
    :class="{'accordion__curriculum':curriculum === '1'}"
  >
    <button
      class="accordion__link"
      :aria-expanded="active"
      @click="toggleActive"
    >
      <span class="heading-x-small accordion__title">{{ title }}</span>
      <img
        class="accordion__toggle"
        :class="{'accordion__toggle--active': active}"
        :style="`--degrees:${angle}deg`"
        src="/themes/custom/education_base/assets/images/icon_plus.svg"
        alt=""
      >
    </button>

    <div
      class="text-small accordion__content"
      :class="{'accordion__content--active': active}"
      :aria-hidden="!active"
    >
      <div class="accordion__content__inner">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  components: {},
  props: {
    title: {
      type: String,
      required: true,
    },
    curriculum: {
      type: String,
      required: false,
      default: '1',
    },
  },
  data() {
    return {
      active: false,
      angle: 0,
    };
  },
  methods: {
    toggleActive() {
      this.active = !this.active;
      this.angle += 45;
    },
  },
};
</script>

<style scoped lang="scss">
.accordion {
  &__curriculum {
    .accordion__link { padding: 1rem 0; }

    .accordion__title { color: #737373; }

    .accordion__content { padding: 0; }
  }

  &__title {
    color: #1E1F27;
    margin: 0;
    padding-right: 1rem;
    text-align: left;
  }

  &__content {
    max-height: 0;
    overflow: auto;
    padding: 0 1rem;
    visibility: hidden;
    transition: all 200ms $transition-timing;

    @include education-breakpoint-tablet-down { padding: 0; }

    &__inner {
      transition: all 200ms ease-in;
      transform: translate3d(0, -1rem, 0);
      opacity: 0;
      padding: 1rem 0;
    }

    &--active {
      max-height: 50rem;
      visibility: visible;

      .accordion__content__inner {
        transform: translate3d(0, 0, 0);
        opacity: 1;
      }
    }
  }

  &__link {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 1rem;
    border: none;
    border-bottom: 0.5px solid #15171E;
    background: transparent;

    @include education-breakpoint-tablet-down { padding: 1rem 0; }

    &:hover {
      .accordion__title { color: $color-blue-active; }

      .accordion__toggle {
        content: url("/web/themes/custom/education_base/assets/images/icon_plus_blue.svg");
      }
    }
  }

  &__toggle {
    width: 1.5rem;
    transition: transform 0.25s ease-out;
    transform: rotate(var(--degrees));
  }
}
</style>
